import { graphql } from '@teachino/shared-infrastructure';

export const deleteMaterialMutation = graphql(`
  mutation DeleteMaterial($id: String!, $topicId: String!, $force: Boolean!) {
    removeMaterial(
      topicMaterialRemoveInput: {
        id: $id
        forceDelete: $force
        topicId: $topicId
      }
    ) {
      __typename
    }
  }
`);
